import { gql } from "@apollo/client";

export const removeCompanyPolicyNudge = gql`
  mutation removeCompanyPolicyNudge($nudgeId: MongoID!) {
    CompanyPolicyNudge_Remove(nudgeId: $nudgeId) {
        _id
    }
  }
`;
